const {
  runFileExtender: baseRunFileExtender
} = require('vue-js-extender');
var mime = require("mime-types");

exports.runFileExtender = (Vue) => {
  if (!!baseRunFileExtender) baseRunFileExtender(Vue);

  //------------------------- File Extensions -------------------------
  File.prototype.getExtension = File.prototype.getExtension || function () {
    if (!this.name) return "";

    let index = this.name.lastIndexOf(".");
    return this.name.substring(index + 1).toLowerCase();
  };
  File.getExtension = File.getExtension || function (target, ...args) {
    if (Object.typeOf(target) !== "file")
      throw new Error("target is not a file.");

    return target.getExtension.apply(target, args);
  };

  File.getMimeType = File.getMimeType || function (ext) {
    let fileType = "";

    if (ext == ".rmd") {
      fileType = "text/plain";
    } else {
      fileType = mime.lookup(ext);
    }

    return fileType || "";
  };
  File.prototype.getMimeType = File.prototype.getMimeType || function () {
    if (!!this.type) return this.type;

    let ext = this.getExtension();
    return File.getMimeType(ext);
  };

  File.convertToFileTypeList = File.convertToFileTypeList || function (exts) {
    let fileTypeList = [];

    exts.forEach((element) => {
      if (!!element) {
        let fileType = File.getMimeType(element);
        if (!!fileType && fileTypeList.indexOf(fileType) < 0) {
          fileTypeList.push(fileType);
        }

        if (element == ".zip") {
          let zipFileTypes = [
            "application/x-compressed",
            "application/x-zip-compressed",
            "application/zip",
            "multipart/x-zip",
          ];
          for (let i = 0; i < zipFileTypes.length; i++) {
            if (fileTypeList.indexOf(zipFileTypes[i]) < 0) {
              fileTypeList.push(zipFileTypes[i]);
            }
          }
        }
      }
    });

    return fileTypeList;
  };
  //------------------------- End -------------------------
};



// WEBPACK FOOTER //
// ./src/core/js-extender/file.extender.js